<div class="wizard-container" id="wizard-container">
  <!-- Loading overlay while validating invite -->
  <div class="loading-overlay" *ngIf="isValidating" id="wizard-validating-overlay">
    <div class="loading-box" id="wizard-validating-box">
      <i class="fas fa-spinner fa-spin loading-icon" id="wizard-validating-icon" aria-hidden="true"></i>
      <div class="loading-text" id="wizard-validating-text">{{ translate('invite.validating') }}</div>
    </div>
  </div>

  <!-- Validation error -->
  <div class="wizard-content" *ngIf="!isValidating && validationError" id="wizard-validation-error">
    <div class="step-welcome validation-error-container">
      <i class="fas fa-exclamation-triangle error-icon"></i>
      <h1 class="step-title">{{ translate(validationError) }}</h1>
      <p class="step-description" *ngIf="validationError === 'invite.invalid_or_expired'">
        {{ translate('invite.invalid_or_expired_desc') }}
      </p>
      <p class="step-description" *ngIf="validationError === 'invite.missing_params'">
        {{ translate('invite.missing_params_desc') }}
      </p>
      <p class="step-description" *ngIf="validationError === 'invite.not_found'">
        {{ translate('invite.not_found_desc') }}
      </p>
      <p class="step-description" *ngIf="validationError === 'invite.server_error'">
        {{ translate('invite.server_error_desc') }}
      </p>
      <div class="wizard-actions">
        <button type="button" class="btn btn-primary" routerLink="/login">
          <i class="fas fa-arrow-left"></i> {{ translate('invite.back_to_login') }}
        </button>
      </div>
    </div>
  </div>

  <!-- Wizard content (only when invite is valid) -->
  <div class="wizard-content" *ngIf="!isValidating && !validationError && invite" id="wizard-content">
    <app-plan-limit-banner
      *ngIf="planLimitError"
      [error]="planLimitError"
      (dismissed)="planLimitError = null">
    </app-plan-limit-banner>

    <!-- Loading overlay shown while submitting the wizard -->
    <div class="loading-overlay" *ngIf="isLoading" id="wizard-loading-overlay">
      <div class="loading-box" id="wizard-loading-box">
        <i class="fas fa-spinner fa-spin loading-icon" id="wizard-loading-icon" aria-hidden="true"></i>
        <div class="loading-text" id="wizard-loading-text">{{ translate('wizard.saving') }}</div>
      </div>
    </div>

    <!-- Progress indicator -->
    <div class="wizard-progress" id="wizard-progress">
      <div class="progress-steps" id="wizard-progress-steps">
        <div *ngFor="let step of steps; let i = index" class="progress-step"
          [ngClass]="{'active': i === currentStep, 'completed': i < currentStep}" [id]="'wizard-progress-step-' + i">
          <div class="step-number" [id]="'wizard-step-number-' + i">{{ i + 1 }}</div>
          <div class="step-label" [id]="'wizard-step-label-' + i">{{ translate(step.title) }}</div>
        </div>
      </div>
      <div class="progress-bar" id="wizard-progress-bar">
        <div class="progress-fill" [style.width.%]="(currentStep / (steps.length - 1)) * 100" id="wizard-progress-fill">
        </div>
      </div>
    </div>

    <!-- Step content -->
    <div class="wizard-step-content glass-effect" id="wizard-step-content">
      <app-invite-wizard-profile-steps [view]="$any(this)"></app-invite-wizard-profile-steps>
      <app-invite-wizard-credentials-and-completion [view]="$any(this)"></app-invite-wizard-credentials-and-completion>
    </div>

    <!-- Navigation buttons -->
    <div class="wizard-actions" id="wizard-actions">
      <button type="button" class="btn btn-outline-secondary" (click)="previousStep()" *ngIf="currentStep > 0"
        id="wizard-btn-previous">
        <i class="fas fa-arrow-left"></i> {{ translate('wizard.previous') }}
      </button>

      <button type="button" class="btn btn-primary" (click)="nextStep()" *ngIf="currentStep < steps.length - 1"
        id="wizard-btn-next">
        {{ translate('wizard.next') }} <i class="fas fa-arrow-right"></i>
      </button>

      <button type="button" class="btn btn-success" (click)="completeWizard()" *ngIf="currentStep === steps.length - 1"
        [disabled]="isLoading" id="wizard-btn-complete">
        <ng-container *ngIf="!isLoading">
          <i class="fas fa-check"></i> {{ translate('wizard.complete') }}
        </ng-container>
        <ng-container *ngIf="isLoading">
          <i class="fas fa-spinner fa-spin"></i> {{ translate('wizard.saving') }}
        </ng-container>
      </button>
    </div>
  </div>
</div>
